angular.module('ics')

    .factory('EmailTemplatesService', function ($http) {

        return {

            getEmailTemplatesList: function (firebaseTokenId, visitorId) {

                let req = {
                    method: 'GET',
                    url: '/api/email_template/list',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000
                };

                return $http(req);


            },

            createEmailTemplate: function (templateName, profileChangeTypes, emailSubject, emailBody, firebaseTokenId, visitorId) {
                let req = {
                    method: 'POST',
                    url: '/api/email_template/',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        'template_name': templateName,
                        'email_body': emailBody,
                        'email_subject': emailSubject,
                        'profile_change_types': profileChangeTypes
                    }
                };

                return $http(req);
            },

            editEmailTemplate: function (emailTemplateId, templateName, profileChangeTypes,
                                         emailSubject, emailBody, firebaseTokenId, visitorId) {
                let req = {
                    method: 'PUT',
                    url: `/api/email_template/${emailTemplateId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        'template_name': templateName,
                        'email_body': emailBody,
                        'email_subject': emailSubject,
                        'profile_change_types': profileChangeTypes
                    }
                };

                return $http(req);
            },

            deleteEmailTemplate: function (emailTemplateId, firebaseTokenId, visitorId) {
                var req = {
                    method: 'DELETE',
                    url: `/api/email_template/${emailTemplateId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000
                };

                return $http(req);
            }
        }

    });
